import {
  Button,
  Center,
  Divider,
  Grid,
  Group,
  Image,
  Paper,
  Stack,
  Text,
  ThemeIcon,
} from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { IconLinkedin } from "../../../../components/Icons/IconLinkedin";
import { IconGmaps } from "../../../../components/Icons/IconGmaps";
import {
  IconBrandZapier,
  IconDatabase,
  IconChevronDown,
  IconSearch,
  IconSparkles,
} from "@tabler/icons-react";
import { IconCSV } from "../../../../components/Icons/IconCSV";
import { useNavigate, useParams } from "react-router-dom";
import { useUIStore } from "../../../../stores/UIStore";
import { Logo } from "../../../../layouts/Logo";
import { useProfileStore, useSessionStore } from "../../../../stores/UserStore";
import {
  getPermission,
  getYouTubeMaxThumbnail,
} from "../../../../functions/utilFunctions";
import mockup_main_fr from "../../../../assets/list-import/main_fr.png";
import mockup_main_en from "../../../../assets/list-import/main_en.png";
import mockup1_fr from "../../../../assets/list-import/1_fr.png";
import mockup2_fr from "../../../../assets/list-import/2_fr.png";
import mockup3_fr from "../../../../assets/list-import/3_fr.png";
import mockup4_fr from "../../../../assets/list-import/4_fr.png";
import mockup1_en from "../../../../assets/list-import/1_en.png";
import mockup2_en from "../../../../assets/list-import/2_en.png";
import mockup3_en from "../../../../assets/list-import/3_en.png";
import mockup4_en from "../../../../assets/list-import/4_en.png";
import { PlayIcon } from "../../../../components/Icons/SvgIcons";
import { useLanguage } from "../../../../stores/LanguageStore";
import VideoModalViewer from "../../../../components/View/VideoModalViewer";
import CreateEmptyList from "./CreateEmptyList";
import lazyRetry from "../../../../functions/lazyRetry";
import Locked from "../../../../components/View/Locked";

const LinkedinImportNew = lazyRetry(() => import("./linkedin/LinkedinImport"));
const LinkedinImport = lazyRetry(() => import("./LinkedinImport"));
const GoogleMapsImport = lazyRetry(() => import("./GoogleMapsImport"));
const AiImport = lazyRetry(() => import("./AiImport"));
const ManualImport = lazyRetry(() => import("./manualImport/ManualImport"));
const TargetingDatabase = lazyRetry(
  () => import("./database/TargetingDatabase"),
);
const LeBonLogicielImport = lazyRetry(
  () => import("./lebonlogiciel/LeBonLogicielImport"),
);
const ZapierImport = lazyRetry(() => import("./ZapierImport"));

const iconProps = { size: 32 };
const imageStyle = { borderRadius: 12, height: "100%" };

const DefaultContent = ({ active }) => {
  const lang = useLanguage((s) => s.language);
  const notReseller = useSessionStore.getState().reseller?.name === "Magileads";
  const video1 = useSessionStore
    .getState()
    .reseller?.videos?.find(
      (x) => x.name === "ListsScrapingSourcesTutorial",
    )?.url;
  const video1_thumbnail = useSessionStore
    .getState()
    .reseller?.videos?.find(
      (x) => x.name === "ListsScrapingSourcesTutorial",
    )?.thumbnail_url;

  const video2 = useSessionStore
    .getState()
    .reseller?.videos?.find(
      (x) => x.name === "ListsScrapeLinkedinTutorial",
    )?.url;
  const video2_thumbnail = useSessionStore
    .getState()
    .reseller?.videos?.find(
      (x) => x.name === "ListsScrapeLinkedinTutorial",
    )?.thumbnail_url;

  const video3 = useSessionStore
    .getState()
    .reseller?.videos?.find(
      (x) => x.name === "ListsScrapeGoogleMapsTutorial",
    )?.url;
  const video3_thumbnail = useSessionStore
    .getState()
    .reseller?.videos?.find(
      (x) => x.name === "ListsScrapeGoogleMapsTutorial",
    )?.thumbnail_url;

  const video4 = useSessionStore
    .getState()
    .reseller?.videos?.find(
      (x) => x.name === "ListsScrapeLinkedinJobPostPublishersTutorial",
    )?.url;
  const video4_thumbnail = useSessionStore
    .getState()
    .reseller?.videos?.find(
      (x) => x.name === "ListsScrapeLinkedinJobPostPublishersTutorial",
    )?.thumbnail_url;

  const video5 = useSessionStore
    .getState()
    .reseller?.videos?.find(
      (x) => x.name === "ListsScrapeLinkedinLikersCommentersTutorial",
    )?.url;
  const video5_thumbnail = useSessionStore
    .getState()
    .reseller?.videos?.find(
      (x) => x.name === "ListsScrapeLinkedinLikersCommentersTutorial",
    )?.thumbnail_url;

  if (active !== "def") {
    return "";
  }
  return (
    <Paper
      className="def-section section animate__animated animate__fadeIn animate__faster"
      justify="center"
      miw={800}
      w={"80%"}
      // mx={"auto"}
      p={"md"}
      pos={"relative"}
    >
      <Grid gutter={"lg"} h={"100%"}>
        {video1 ? (
          <VideoModalViewer
            src={video1}
            opener={(handleOpen) => (
              <Grid.Col
                span={8}
                pos={"relative"}
                className="cover"
                onClick={handleOpen}
              >
                <PlayIcon
                  variant="light"
                  color="primary"
                  size={64}
                  iconSize={32}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 10,
                  }}
                  radius={64}
                  className="play-button"
                />

                {video1.includes("youtube") || video1_thumbnail ? (
                  <Image
                    src={getYouTubeMaxThumbnail(
                      video1,
                      "ListsScrapeLinkedinLikersCommentersTutorial",
                    )}
                    style={imageStyle}
                  />
                ) : (
                  <video
                    src={video1}
                    className="reseller-video"
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "block",
                    }}
                  />
                )}
              </Grid.Col>
            )}
          />
        ) : notReseller ? (
          <VideoModalViewer
            src={
              "https://www.youtube.com/embed/Jz8aTNhJabg?si=w188fZTPDUSJYaIE"
            }
            opener={(handleOpen) => (
              <Grid.Col
                span={8}
                pos={"relative"}
                className="cover"
                onClick={handleOpen}
              >
                <PlayIcon
                  variant="light"
                  color="white"
                  size={128}
                  iconSize={64}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 10,
                  }}
                  radius={64}
                  className="play-button"
                />
                <Image
                  src={lang.id === "FRA" ? mockup_main_fr : mockup_main_en}
                  style={imageStyle}
                />
              </Grid.Col>
            )}
          />
        ) : (
          ""
        )}

        {video2 ? (
          <VideoModalViewer
            src={video2}
            opener={(handleOpen) => (
              <Grid.Col
                span={4}
                pos={"relative"}
                className="cover"
                onClick={handleOpen}
                style={{ display: "flex", alignItems: "center" }}
              >
                <PlayIcon
                  variant="light"
                  color="primary"
                  size={64}
                  iconSize={32}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 10,
                  }}
                  radius={64}
                  className="play-button"
                />

                {video2.includes("youtube") || video2_thumbnail ? (
                  <Image
                    src={getYouTubeMaxThumbnail(
                      video2,
                      "ListsScrapeLinkedinTutorial",
                    )}
                    style={imageStyle}
                  />
                ) : (
                  <video
                    src={video2}
                    className="reseller-video"
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "block",
                    }}
                  />
                )}
              </Grid.Col>
            )}
          />
        ) : notReseller ? (
          <VideoModalViewer
            src={
              "https://www.youtube.com/embed/hhf1nji2T3U?si=0rdrHulh4AhDxp2Z"
            }
            opener={(handleOpen) => (
              <Grid.Col
                span={4}
                pos={"relative"}
                className="cover"
                onClick={handleOpen}
              >
                <PlayIcon
                  variant="light"
                  color="white"
                  size={96}
                  iconSize={48}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 10,
                  }}
                  radius={64}
                  className="play-button"
                />
                <Image
                  src={lang.id === "FRA" ? mockup1_fr : mockup1_en}
                  style={imageStyle}
                />
              </Grid.Col>
            )}
          />
        ) : (
          ""
        )}

        {video3 ? (
          <VideoModalViewer
            src={video3}
            opener={(handleOpen) => (
              <Grid.Col
                span={4}
                pos={"relative"}
                className="cover"
                onClick={handleOpen}
              >
                <PlayIcon
                  variant="light"
                  color="primary"
                  size={64}
                  iconSize={32}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 10,
                  }}
                  radius={64}
                  className="play-button"
                />

                {video3.includes("youtube") || video3_thumbnail ? (
                  <Image
                    src={getYouTubeMaxThumbnail(
                      video3,
                      "ListsScrapeGoogleMapsTutorial",
                    )}
                    style={imageStyle}
                  />
                ) : (
                  <video
                    src={video3}
                    className="reseller-video"
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "block",
                    }}
                  />
                )}
              </Grid.Col>
            )}
          />
        ) : notReseller ? (
          <VideoModalViewer
            src={
              "https://www.youtube.com/embed/2rmHMBb0Yf0?si=7nY07Mrx4EyDS_Ue"
            }
            opener={(handleOpen) => (
              <Grid.Col
                span={4}
                pos={"relative"}
                className="cover"
                onClick={handleOpen}
              >
                <PlayIcon
                  variant="light"
                  color="white"
                  size={96}
                  iconSize={48}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 10,
                  }}
                  radius={64}
                  className="play-button"
                />
                <Image
                  src={lang.id === "FRA" ? mockup2_fr : mockup2_en}
                  style={imageStyle}
                />
              </Grid.Col>
            )}
          />
        ) : (
          ""
        )}

        {video4 ? (
          <VideoModalViewer
            src={video4}
            opener={(handleOpen) => (
              <Grid.Col
                span={4}
                pos={"relative"}
                className="cover"
                onClick={handleOpen}
              >
                <PlayIcon
                  variant="light"
                  color={"primary"}
                  size={64}
                  iconSize={32}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 10,
                  }}
                  radius={64}
                  className="play-button"
                />

                {video4.includes("youtube") || video4_thumbnail ? (
                  <Image
                    src={getYouTubeMaxThumbnail(
                      video4,
                      "ListsScrapeLinkedinJobPostPublishersTutorial",
                    )}
                    style={imageStyle}
                  />
                ) : (
                  <video
                    src={video4}
                    className="reseller-video"
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "block",
                    }}
                  />
                )}
              </Grid.Col>
            )}
          />
        ) : notReseller ? (
          <VideoModalViewer
            src={
              "https://www.youtube.com/embed/-7B4vG3iyMc?si=bKpbI6vsWjl12inN"
            }
            opener={(handleOpen) => (
              <Grid.Col
                span={4}
                pos={"relative"}
                className="cover"
                onClick={handleOpen}
              >
                <PlayIcon
                  variant="light"
                  color="white"
                  size={96}
                  iconSize={48}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 10,
                  }}
                  radius={64}
                  className="play-button"
                />
                <Image
                  src={lang.id === "FRA" ? mockup3_fr : mockup3_en}
                  style={imageStyle}
                />
              </Grid.Col>
            )}
          />
        ) : (
          ""
        )}

        {video5 ? (
          <VideoModalViewer
            src={video5}
            opener={(handleOpen) => (
              <Grid.Col
                span={4}
                pos={"relative"}
                className="cover"
                onClick={handleOpen}
              >
                <PlayIcon
                  variant="light"
                  color={"primary"}
                  size={64}
                  iconSize={32}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 10,
                  }}
                  radius={64}
                  className="play-button"
                />

                {video5.includes("youtube") || video5_thumbnail ? (
                  <Image
                    src={getYouTubeMaxThumbnail(
                      video5,
                      "ListsScrapeLinkedinLikersCommentersTutorial",
                    )}
                    style={imageStyle}
                  />
                ) : (
                  <video
                    src={video5}
                    className="reseller-video"
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "block",
                    }}
                  />
                )}
              </Grid.Col>
            )}
          />
        ) : notReseller ? (
          <VideoModalViewer
            src={
              "https://www.youtube.com/embed/qD_Ch6fRwpE?si=aWIaVWP-GamY5kdH"
            }
            opener={(handleOpen) => (
              <Grid.Col
                span={4}
                pos={"relative"}
                className="cover"
                onClick={handleOpen}
              >
                <PlayIcon
                  variant="light"
                  color="white"
                  size={96}
                  iconSize={48}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 10,
                  }}
                  radius={64}
                  className="play-button"
                />
                <Image
                  src={lang.id === "FRA" ? mockup4_fr : mockup4_en}
                  style={imageStyle}
                />
              </Grid.Col>
            )}
          />
        ) : (
          ""
        )}
      </Grid>
    </Paper>
  );
};

const ContactListImport = () => {
  const lang = useLanguage((s) => s.language);
  const folderId = parseInt(useParams().folderId, 10);
  const listId = parseInt(useParams().contactListId, 10);
  const reseller = useSessionStore((s) => s.reseller);

  const hasVideo = reseller?.videos?.find((x) => x.name.includes("ListsScrap"));

  const elements = useMemo(() => {
    let result = {};

    if (getPermission("displayTargetingLinkedin")) {
      result.linkedin = {
        label: "LinkedIn",
        icon: <IconLinkedin {...iconProps} />,
        text: lang.import_contacts.linkedin.text,
        path: "import/linkedin",
        lockable: true,
      };
    }

    if (getPermission("displayTargetingGoogle")) {
      result.gmaps = {
        label: "Google Maps",
        icon: <IconGmaps {...iconProps} />,
        text: lang.import_contacts.google.text,
        path: "import/google",
        lockable: true,
      };
    }

    result.manual = {
      label: lang.import_contacts.manual.label,
      icon: <IconCSV {...iconProps} />,
      text: lang.import_contacts.manual.text,
      path: "import/manual",
    };

    if (getPermission("displayTargetingDatabase")) {
      result.database = {
        label:
          lang.import_contacts.database.label +
            " " +
            useSessionStore.getState().reseller?.name || "",
        icon: <Logo isLoader />,
        text: lang.import_contacts.database.text,
        path: "import/database",
      };
    }

    if (getPermission("displayTargetingDatabase") && reseller?.name === "LeBonLogiciel") {
      result.lebonlogiciel = {
        label: lang.import_contacts.lebonlogiciel.label,
        icon: <IconDatabase {...iconProps} />,
        text: lang.import_contacts.lebonlogiciel.text,
      };
    }

    if (getPermission("accessSearchAI")) {
      result.ai = {
        label: lang.import_contacts.ai.label,
        icon: (
          <IconSparkles {...iconProps} fill="var(--mantine-color-primary-6)" />
        ),
        text: lang.import_contacts.ai.text,
        path: "import/quick",
      };
    }

    if (reseller?.name === "Magileads") {
      result.zapier = {
        label: lang.import_contacts.zapier.label,
        icon: (
          <IconBrandZapier
            {...iconProps}
            fill="var(--mantine-color-primary-6)"
          />
        ),
        text: lang.import_contacts.zapier.text,
        path: "import/zapier",
      };
    }

    // Andzup button
    // if (reseller?.domain_saas3 === "flow.andzup.com") {
    //   result.andzup = {
    //     label: "Andzup",
    //     icon: (
    //       <img
    //         src="https://app.files-magileads.net/resellers/image/68D40984D423E943576615.png"
    //         width={32}
    //         height={32}
    //       />
    //     ),
    //     text: "",
    //     path: "",
    //     disabled: true,
    //   };
    // }

    return result;
  }, [lang, reseller]);

  const [active, setActive] = useState(
    reseller?.name === "Magileads" || hasVideo
      ? "def"
      : elements?.linkedin
        ? "linkedin"
        : "manual",
  );

  const navigate = useNavigate();
  const handleFinish = (newListId) => {
    if (newListId) {
      navigate(
        folderId
          ? `/contact-lists/folder/${folderId}/list/${newListId}`
          : `/contact-lists/${newListId}`,
      );
    } else {
      navigate(
        folderId
          ? `/contact-lists/folder/${folderId}`
          : `/contact-lists/none?highlight=${listId}`,
      );
    }
  };

  useEffect(() => {
    let locked = useUIStore.getState().pinnedNavbar;
    if (!locked) {
      useUIStore.getState().setNavbarClosed(true);
      useUIStore.getState().setCampaignOpened(false);
    }

    let params = new URLSearchParams(window.location.search);
    let type = params.get("type");
    if (type && elements[type]) {
      setActive(type);
    } else {
      setActive("def");
    }
  }, []);

  return (
    <Stack
      flex={1}
      pb={16}
      mx={0}
      mt={16}
      px={32}
      w={"100%"}
      className="list-import"
    >
      {/* <Title order={3} mt={20} fw={500} ml={32}>
        Suivez ces étapes pour créer vos listes de contacts.
      </Title>

      <Divider mb={16} /> */}
      <Group mb={0}>
        <ThemeIcon size={"xl"} radius={"md"} variant="filled" color="primary">
          <IconSearch size={32} />
        </ThemeIcon>

        <Text fw={700} fz={24}>
          {lang.import_contacts.title}
        </Text>
      </Group>

      <Group wrap="nowrap" align="start" gap={"xl"}>
        <Stack w={"25%"} miw={500} className="buttons" gap={0}>
          {Object.keys(elements).map((key) => {
            let item = elements[key];

            if (key === "def") {
              return "";
            }

            return (
              <Group wrap="nowrap" key={key}>
                <Locked
                  disableLock={!item.lockable}
                  boxProps={{ w: active === key ? "100%" : "90%" }}
                  buttonProps={{ size: "xs" }}
                  right={64}
                  top={20}
                  withStar
                >
                  {(isLocked) => (
                    <Button
                      disabled={isLocked}
                      opacity={isLocked ? 0.5 : 1}
                      size="xl"
                      w={isLocked ? "100%" : active === key ? "100%" : "90%"}
                      justify="start"
                      radius={"lg"}
                      mt={isLocked ? 0 : "sm"}
                      mb={"sm"}
                      variant={active === key ? "light" : "default"}
                      className="bump-stroke test no-shadow"
                      leftSection={
                        <ThemeIcon
                          variant="subtle"
                          size={"lg"}
                          radius={"lg"}
                          // color="secondary"
                        >
                          {item.icon}
                        </ThemeIcon>
                      }
                      rightSection={
                        <IconChevronDown
                          size={24}
                          opacity={active === key ? 1 : 0.4}
                          style={{
                            transform:
                              active === key ? "rotate(-90deg)" : "none",
                            transition: "all ease .3s",
                          }}
                        />
                      }
                      styles={{
                        label: {
                          marginLeft: 16,
                        },
                      }}
                      onClick={() => {
                        if (reseller?.name === "Magileads") {
                          setActive(active === key ? "def" : key);
                        } else {
                          setActive(key);
                        }
                      }}
                      style={{
                        transition: "all ease .3s",
                        opacity:
                          active === "def" ? 1 : active === key ? 1 : 0.5,
                        border: "1px solid var(--mantine-color-primary-0)",
                      }}
                      h={80}
                    >
                      <Stack w={"100%"} align="start" gap={0}>
                        <Text fz={18} fw={600} c={"#333"}>
                          {item.label}
                        </Text>
                        <Text
                          c={"gray"}
                          size="sm"
                          w={"100%"}
                          style={{ textWrapMode: "wrap" }}
                          ta={"left"}
                        >
                          {item.text}
                        </Text>
                      </Stack>
                    </Button>
                  )}
                </Locked>

                {active !== key && <Divider ml={16} orientation="vertical" />}
              </Group>
            );
          })}

          <Group justify="end">
            <CreateEmptyList onFinish={handleFinish} />
          </Group>
        </Stack>

        <Stack
          flex={"1 1 auto"}
          gap={0}
          pos={"relative"}
          style={{ overflow: "auto", minHeight: 400 }}
          h={"80vh"}
          pt={0}
          pb={16}
        >
          {(reseller?.name === "Magileads" || hasVideo) && (
            <DefaultContent active={active} onFinish={handleFinish} />
          )}

          <LinkedinImportNew
            active={active}
            setActive={setActive}
            onFinish={handleFinish}
          />

          {/* {
            useProfileStore?.getState()?.profile?.level === "admin" ?
              <LinkedinImportNew
                active={active}
                setActive={setActive}
                onFinish={handleFinish}
              />
              :
              <LinkedinImport
                active={active}
                setActive={setActive}
                onFinish={handleFinish}
              />

          } */}

          <GoogleMapsImport
            setActive={setActive}
            active={active}
            onFinish={handleFinish}
          />

          <AiImport
            setActive={setActive}
            active={active}
            onFinish={handleFinish}
          />

          <ManualImport
            setActiveWindow={setActive}
            isActive={active}
            onFinish={handleFinish}
          />

          <TargetingDatabase
            setActive={setActive}
            active={active}
            onFinish={handleFinish}
          />

          {active === "lebonlogiciel" && elements.lebonlogiciel && (
            <LeBonLogicielImport onFinish={handleFinish} />
          )}

          <ZapierImport setActive={setActive} active={active} />
        </Stack>
      </Group>
    </Stack>
  );
};

export default ContactListImport;
